import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import _ from 'lodash';
import moment from 'moment';
import { Popover, Modal, message } from 'antd';
import ReactTable from 'react-table';
import 'react-table/react-table.css';

import { 
    fetchAllOrders, 
    fetchOrders,
    shipOrder
} from '../../actions/Order';
import CartPopoverContent from './CartPopoverContent';
import AddressPopoverContent from './AddressPopoverContent';
import TrackingModal from './TrackingModal';

import { latestStatus } from '../../utils/Utils';

const $ = window.$;

class Orders extends Component {

    constructor(props) {
        super(props);

        this.state = {
            filterStatus: 'all',
            showTrackingModal: false,
            selectedOrderId: '',
            backendOrderId: '',
            uid: '',
            sortedOrders: []
        }
    }

    componentDidMount() {

        $(".status").on('click', 'li a', function () {
            $(".btn.status-list:first-child").text($(this).text());
            $(".btn.status-list:first-child").val($(this).text());
        });

        $("[data-toggle=popover]").popover({
            html: true,
            content: function () {
                return $('.popover-content').html();
            }
        });

        this.props.fetchOrders(moment.valueOf(), 10);
    }

    componentDidUpdate(prevProps, prevState) {

        $('.dropdown-btn, .dropdown-group-btn').hover(function () {
            $(this).find('.dropdown-menu').stop(true, true).delay(100).fadeIn(250);
        }, function () {
            $(this).find('.dropdown-menu').stop(true, true).delay(100).fadeOut(250);
        });

        $('.badge').click(function () {
            $(this).toggleClass("active");
        });
    }

    componentWillReceiveProps(nextProps) {
        
        this.processOrders(nextProps.orders);
    }

    processOrders(orders) {

        const sortedOrders = _.toArray(orders);
        this.setState({ sortedOrders: sortedOrders });
    }

    onSelectStatusDropdown(status) {
        this.setState({ filterStatus: status });
    }

    onViewDetailClick(order) {

    }

    onCancelClick(order) {

    }

    onMouseOverCart(order) {

    }

    onMouseOutCart(order) {

    }

    onModalCancel() {
        this.setState({
            showTrackingModal: false,
            selectedOrderId: '',
            backendOrderId: '',
            uid: ''
        });
    }

    onModalSubmit(modal, trackingNumber) {
        // submit tracking
        const { backendOrderId, uid } = this.state;

        this.props.shipOrder(uid, backendOrderId, trackingNumber, (success) => {

            modal.onShipOrderFinish(success);

            console.log(success);
            // hide modal
            if (success) {
                this.setState({
                    showTrackingModal: false,
                    selectedOrderId: '',
                    backendOrderId: '',
                    uid: ''
                });

                message.success('Notification has been sent to customer.');
                
                this.props.fetchOrders(moment.valueOf(), 10);
            } else {
                message.error('Error');
            }
        });
    }

    onShipClick(order) {

        this.setState({
            showTrackingModal: true,
            selectedOrderId: `${order.PaymentResponse.tranRef}`,
            backendOrderId: `${order.orderId}`,
            uid: `${order.uid}`
        });
    }

    renderStatusDropdown() {
        return (
            <div className="dropdown sort-dropdown status">
                <button className="btn dropdown-toggle sort-list status-list" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                    All Status
                            </button>
                <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton">
                    <li>
                        <a className="dropdown-item" onClick={() => this.onSelectStatusDropdown('all')}>All Status</a>
                    </li>
                    <li>
                        <a className="dropdown-item" onClick={() => this.onSelectStatusDropdown('payment')}>Awaiting Payment</a>
                    </li>
                    <li>
                        <a className="dropdown-item" onClick={() => this.onSelectStatusDropdown('shipment')}>Awaiting Shipment</a>
                    </li>
                    <li>
                        <a className="dropdown-item" onClick={() => this.onSelectStatusDropdown('shipped')}>Shipped</a>
                    </li>
                    <li>
                        <a className="dropdown-item" onClick={() => this.onSelectStatusDropdown('canceled')}>Canceled</a>
                    </li>
                </ul>
            </div>
        );
    }

    renderStatus(status) {
        console.log(status);

        switch (status) {
            case 'payment':
                return (
                    <div>
                        <span className="circle orange-circle"></span>
                        Awaiting Payment
                    </div>
                );
            case 'shipment':
                return (
                    <div>
                        <span className="circle blue-circle"></span>
                        Awaiting Shipment
                    </div>
                );
            case 'shipped':
                return (
                    <div>
                        <span className="circle green-circle"></span>
                        Shipped
                    </div>
                );
            case 'canceled':
                return (
                    <div>
                        <span className="circle red-circle"></span>
                        Canceled
                    </div>
                );
        }
        return (
            <div>
                <span className="circle red-circle"></span>
                Unknown
            </div>
        );
    }

    sortProperties(obj) {
        // convert object into array
        let sortable = [];
        for (var key in obj) {
            if (obj.hasOwnProperty(key)) {
                sortable.push([key, obj[key]]); // each item is an array in format [key, value]
            }
        }
        // sort items by value
        sortable.sort(function (a, b) {
            return b[1] - a[1]; // compare numbers
        });
        return sortable; // array in format [ [ key1, val1 ], [ key2, val2 ], ... ]
    }

    renderDropdown(order, status) {
        const content = (
            <div >
                <Link to={`/orders/${order.uid}/${order.orderId}`} className="dropdown-item">View Details</Link>
                {status !== 'canceled' ? <button className="dropdown-item" onClick={() => this.onCancelClick(order)}>Cancel this Order</button> : null}
            </div>
        );

        return (
            <Popover placement="left" content={content}>
                <div className="dropdown dropdown-btn">
                    <img src="/resources/img/more-vert.png" alt="more vert icon" />
                </div>
            </Popover>
        );
    }

    renderCustomer(order) {
        return (
            <Popover placement="topLeft" content={<AddressPopoverContent order={order} />}>
                <div>{order.address.name}</div>
            </Popover>
        );
    }

    renderBadge(order) {
        if (order.items && _.size(order.items) > 0) {

            return (
                <Popover placement="left" content={<CartPopoverContent order={order} />}>
                    <div
                        className="badge"
                        data-badge={_.size(order.items)}
                        // data-placement="left"
                        // data-toggle="popover"
                        // data-container="body"
                        // data-placement="left"
                        // data-html="true"
                        onMouseOver={() => this.onMouseOverCart(order)}
                        onMouseOut={() => this.onMouseOutCart(order)}
                    >
                        <img src="/resources/img/ic-cart.png" alt="cart" />
                    </div>
                </Popover>
            );
        }
        return (
            <Popover placement="left" content={<CartPopoverContent order={order} />}>
                <img src="/resources/img/ic-cart.png" alt="cart" style={{ width: 24, height: 24 }} />
            </Popover>
        );
    }

    renderShipButton(order, status) {
        let className = 'green-btn';
        let event = {};
        if (status === 'canceled' || status === 'shipped') {
            className = 'gray-btn disable';
            event = { pointerEvents: 'none' };
        }

        return (
            <button
                className={`btn button small-btn ${className}`}
                type="button"
                onClick={() => this.onShipClick(order)}
                style={event}
            >
                {'Ship'}
            </button>
        );
    }

    renderTable() {
        const { orders, isLoading } = this.props;
        const { sortedOrders } = this.state;
        
        return (
            <ReactTable
                // style={{border: 0}}
                data={sortedOrders}
                loading={isLoading}
                columns={[
                    {
                        Header: <div>{'Order'}</div>,
                        id: 'orderNumber',
                        accessor: d => d.PaymentResponse.tranRef
                    },
                    {
                        Header: 'Customer',
                        id: 'customer',
                        accessor: d => this.renderCustomer(d)
                    },
                    {
                        Header: 'Order Date',
                        id: 'orderDate',
                        accessor: d => moment(d.createdDate).format('DD MMM YYYY, HH:mm')
                    },
                    {
                        Header: 'Status',
                        id: 'status',
                        accessor: d => this.renderStatus(latestStatus(d.status))
                    },
                    {
                        Header: '',
                        id: 'badge',
                        className: 'col-center',
                        accessor: d => this.renderBadge(d),
                        width: 50
                    },
                    {
                        Header: '',
                        id: 'shippedButton',
                        className: 'col-center',
                        accessor: d => this.renderShipButton(d, latestStatus(d.status)),
                        width: 90
                    },
                    {
                        Header: '',
                        id: 'actionButton',
                        className: 'col-center',
                        accessor: d => this.renderDropdown(d, latestStatus(d.status)),
                        width: 30
                    }
                ]}
                defaultPageSize={10}
                className="-striped -highlight"
            />
        );
    }

    // renderOrderRows() {
    //     const { orders } = this.props;
    //     const { filterStatus } = this.state;

    //     if (!orders) {
    //         return null;
    //     }

    //     const rows = this.props.orders.map(order => {

    //         const status = 'all'//this.sortProperties(order.status)[0][0]

    //         if (filterStatus === 'all') {
    //             // all
    //         } else {
    //             if (filterStatus !== status) {
    //                 return;
    //             }
    //         }
    //         // 10 Jul 2017, 10.00 A
    //         return (
    //             <tr key={order.orderId}>
    //                 <td onClick={() => this.onViewDetailClick(order)}>{order.userVisibleId}</td>
    //                 <td onClick={() => this.onViewDetailClick(order)}>Adisak Whiteseagal</td>
    //                 <td onClick={() => this.onViewDetailClick(order)}>{moment(order.createdDate * 1000).format('DD MMM YYYY, HH:mm')}</td>
    //                 <td onClick={() => this.onViewDetailClick(order)}>
    //                     {this.renderStatus(status)}
    //                 </td>
    //                 <td>
    //                     {this.renderBadge(order)}
    //                 </td>
    //                 <td>
    //                     {this.renderShipButton(order, status)}
    //                 </td>
    //                 <td>
    //                     {this.renderDropdown(order, status)}
    //                 </td>
    //             </tr>
    //         );
    //     });
    //     return rows;
    // }

    render() {

        const { sortedOrders, showTrackingModal, selectedOrderId } = this.state;

        return (
            <div className="main-content">
                <div className="page-title">Orders</div>
                <div className="divider"></div>
                <div className="function orders-list">
                    <div className="row">
                        <div className="col-md-auto">
                            <div className="input-group search-box">
                                <input type="text" className="form-control" placeholder="Search..." name="search-box" />
                            </div>
                        </div>
                        <div className="col-3">
                            {this.renderStatusDropdown()}
                        </div>
                        <div className="col">
                        </div>
                    </div>
                </div>
                {sortedOrders.length > 0 ? this.renderTable() : null}
                {/* <table ref="orderList" id="order-list" className="table table-list hover table-dropdown" cellSpacing="0" width="100%">
                    <thead>
                        <tr>
                            <th>Order</th>
                            <th>Customer</th>
                            <th>Order date</th>
                            <th>Status</th>
                            <th></th>
                            <th></th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        {this.renderOrderRows()}
                    </tbody>
                </table> */}
                <Modal
                    visible={showTrackingModal}
                    closable={false}
                    footer={null}
                >
                    <TrackingModal
                        onCancel={this.onModalCancel.bind(this)}
                        onAdd={this.onModalSubmit.bind(this)}
                        orderId={selectedOrderId}
                    />
                </Modal>
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    const { orders, isLoading } = state.order;
    return { orders, isLoading };
};

export default connect(mapStateToProps, { fetchAllOrders, fetchOrders, shipOrder })(Orders);



// WEBPACK FOOTER //
// ./src/views/orders/index.js